import getWeek from './getWeek';

/**
 * Check if two given dates are in the same week.
 */
export default function isSameWeek(a, b) {
  return getWeek(a) === getWeek(b);
}
